import { checkIsValidPeriod } from "./private/checkIsValidPeriod";
import { checkIsMovable } from "./private/checkIsMovable";

// 返却ボタンを表示するかどうか
export const checkIsRestorable = (masterBook, book) => {
  return (
    masterBook.transferable &&
    !book.is_valid &&
    checkIsValidPeriod(book) &&
    checkIsMovable(book) &&
    book.transfer_status == "restorable"
  );
};
